import { Grid } from "@mui/material";
import { wholeRow } from "../../../constants/global";
import StyledGridCell from "../StyledGridCell/StyledGridCell";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";

const NoItemYetContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(4),
}));

const TextOnlyContainer = styled("span")({
  display: "inline",
});

interface EmptyItemProps {
  text: string;
  delay?: number;
  textOnly?: boolean;
  sx?: object;
}

const EmptyItem = ({ text, delay, textOnly = false, sx }: EmptyItemProps) => {
  const [activeText, setActiveText] = useState("");
  
  useEffect(() => {
    if (text) {
      setTimeout(() => {
        setActiveText(text);
      }, delay || 1000);
    } else {
      setActiveText(text);
    }
  }, [text, delay]);

  // If textOnly is true, just render a span (compatible with p elements)
  if (textOnly) {
    return <TextOnlyContainer sx={sx}>{activeText}</TextOnlyContainer>;
  }

  // Otherwise render the full container version
  return (
    <Grid container>
      <StyledGridCell {...wholeRow}>
        <NoItemYetContainer style={{ textAlign: "center" }}>
          <b>{activeText}</b>
        </NoItemYetContainer>
      </StyledGridCell>
    </Grid>
  );
};

export { EmptyItem };
